var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.463,
    height: 19.15,
    viewBox: "0 0 25.463 19.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.642,145.793l-2.746-2.084a.819.819,0,0,0-1.314.653v1.276h-.813v-1.289a.819.819,0,0,0-.819-.82h-1.631v-3.044a.82.82,0,0,0-.82-.82h-2.55v-.87h.687a.82.82,0,1,0,0-1.639h-5.3a.82.82,0,1,0,0,1.639h.687v.87H139.86a.819.819,0,0,0-.82.82v1.6h-1.6a.819.819,0,0,0-.82.819v1.875h-1.478v-2.325a.82.82,0,0,0-1.639,0v8.573a.82.82,0,0,0,1.639,0V148.7h1.478v1.922a.819.819,0,0,0,.82.82H139.5L142.393,155a.819.819,0,0,0,.636.3h8.923a.82.82,0,0,0,.82-.82V153.4h.812v1.083a.819.819,0,0,0,1.352.622l2.746-2.353a.819.819,0,0,0,.286-.623v-5.687A.822.822,0,0,0,157.642,145.793Z",
    transform: "translate(-133.003 -136.656)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.5ba32607e20547a6b622d6f657d0959c.svg";
export { ForwardRef as ReactComponent };